import { ANDROID_STORE, IOS_STORE } from '../lib/vendorGateway';

// Official store badge artwork (Apple App Store Marketing Guidelines, Google
// Play Badge Guidelines). Both render at the same height, link straight to
// the store listing and keep the badge text as alt so screen readers and
// tests still see "Download on the App Store" / "Get it on Google Play".
const BADGES = {
	ios: { href: IOS_STORE, src: '/badges/app-store-badge.svg', alt: 'Download on the App Store', width: 120 },
	android: { href: ANDROID_STORE, src: '/badges/google-play-badge.png', alt: 'Get it on Google Play', width: 134 },
} as const;

export type StoreBadgeKind = keyof typeof BADGES;

export function StoreBadge({ store, height = 48, className }: { store: StoreBadgeKind; height?: number; className?: string }) {
	const b = BADGES[store];
	const width = Math.round(b.width * (height / 40));
	return (
		<a className={className ? `store-badge ${className}` : 'store-badge'} href={b.href} rel="noreferrer" referrerPolicy="no-referrer">
			<img src={b.src} alt={b.alt} width={width} height={height} decoding="async" />
		</a>
	);
}
